import { CustomersPhoneNumberType } from "@/types/customer/customer.type";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
let PhoneNumber = require("awesome-phonenumber");
window["PhoneNumber"] = PhoneNumber;
export interface CustomerPhoneInterface {
  selected?: boolean;
  country: string;
  number: string;
  getData(): any;
  toJson(): any;
  prepareNumberFormData(): void;
  select(): void;
  unSelect(): void;
}

export class CustomerPhoneModule implements CustomerPhoneInterface {
  id?: string | null;
  number: string = "";
  is_primary: boolean = false;
  is_verified: boolean = true;
  is_valid: boolean = false;
  national?: string = "";
  international?: string = "";
  county_code?: string = "";
  selected?: boolean = false;
  country: string = "";

  constructor(phone?: CustomersPhoneNumberType) {
    this.id = phone?.id || null;
    this.is_primary = phone?.is_primary || false;
    this.is_verified = phone?.is_verified || false;
    this.number = `${phone?.number || ""}`;
    this.is_valid = phone?.is_valid || false;
    this.county_code = phone?.county_code || "";
    this.selected = phone?.is_primary || false;
    this.country = phone?.country || this.getBusinessCountryCode();

    if (!!phone?.number) {
      let phoneNumber = PhoneNumber(`${phone.number}`, this.country);

      this.national = phoneNumber.getNumber("national");
      this.international = phoneNumber.getNumber();
    }
  }

  getData(): any {
    return {
      id: this.id,
      is_primary: this.is_primary,
      is_verified: this.is_verified,
      number: this.national,
      is_valid: this.is_valid,
      country: this.country,
    };
  }

  toJson(): any {
    const international = this.international || "";
    return {
      id: this.id,
      is_primary: this.is_primary,
      is_verified: this.is_verified,
      number: parseInt(international),
      is_valid: this.is_valid,
      country: this.country,
    };
  }

  prepareNumberFormData(): void {
    if (this.number) {
    }
  }

  /***
   * handle select phone
   * @return {void}
   */
  public select(): void {
    this.selected = true;
  }

  /***
   * handle unSelect phone
   * @return {void}
   */
  public unSelect(): void {
    this.selected = false;
  }

  private getBusinessCountryCode(): string {
    return Storage.get(StorageConstants.BUSINESS)?.country?.toString()?.toLowerCase();
  }
}
